//import Vue from 'vue'
import Vuex from "vuex";
import { http, apis } from "@/apis/apis.js";

var $http;
var defultState = {};
var defultMutations = {};

var getters = {};

export default (app) => {
  $http = http.bind(app);
  return new Vuex.Store({
    state: defultState,
    mutations: defultMutations,
    getters
  });
};
